import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import './styles.scss';

class Collapse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open ?? false,
    };
  }

  handleCollapseClick = () => {
    if (typeof window['digitalData'] !== 'undefined') {
      window.digitalData.link = {
        linkName: this.props && this.props.title,
        linkType: 'FAQ',
      };
    }

    AnalyticsService.trackEvent('link_click');
    this.setState((prevState) => {
      return { open: !prevState.open };
    });
  };

  render() {
    const { title = 'Collapse Title', children } = this.props;
    const { open } = this.state;
    return (
      <div className="collapse-wrapper" onClick={this.handleCollapseClick}>
        <h3 className="collapse-title-caret-container">
          <FontAwesomeIcon icon={open ? 'angle-up' : 'angle-down'} />
          <span className="collapse-title">{title}</span>
        </h3>
        {open && (
          <div className="collapse-wrapper__collapse-data">{children}</div>
        )}
      </div>
    );
  }
}

export default Collapse;
